import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseUpdatePrivateCompanyLeadContractFileProps {
  id?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useUpdatePrivateCompanyLeadContractFile = ({
  id,
  onSuccess,
  onError,
}: UseUpdatePrivateCompanyLeadContractFileProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updatePrivateCompanyLeadContractFile'],
    mutationFn: async (file: Blob) => {
      const private_company_lead = {
        contract_attributes: {
          file,
        },
      }

      await privateAxios.putForm(`/funnel/private_company_leads/${id}`, {
        private_company_lead,
      })
    },
    onSuccess,
    onError,
  })
}
